import { List, Map } from 'immutable';
import { records as tunnelRecords } from '@saucelabs/sl-module-tunnels';
import { records as userRecords } from '@saucelabs/sl-module-user';
import { TM_DEFAULT_TEAM_DISPLAY_NAME } from '@saucelabs/sl-util-config';

import {
  ACTIVITY_GET,
  ADD_TEAM_MEMBERSHIP,
  CLEANUP,
  INITIALIZED,
  REMOVE_TEAM_MEMBERSHIP,
  RESET_ACCESS_KEY,
  STOP_TUNNEL,
  TUNNELS_GET,
  USER_GET,
  USER_GET_ACCESS_KEY,
} from './types';
import { types as teamsTypes } from './../teams';
import { types as usersTypes } from './../users';

const initialState = Map({
  activity: {},
  loading: true,
  teams: List(),
  tunnels: List(),
  user: new userRecords.UserRecord(),
});

const userDetailsReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case INITIALIZED:
      return state.set('loading', false);
    case CLEANUP:
      return initialState;
    case USER_GET.SUCCESS:
    case usersTypes.USER_PATCH.SUCCESS:
    case usersTypes.ROLE_UPDATE.SUCCESS:
    case USER_GET_ACCESS_KEY.SUCCESS: {
      const userObject = state.get('user').toJS();
      return state.set('user', new userRecords.UserRecord({ ...userObject, ...payload }));
    }
    case ACTIVITY_GET.SUCCESS:
      return state.set('activity', payload);
    case TUNNELS_GET.SUCCESS: {
      const allTunnels = Object.values(payload)
        .reduce((acc, tunnelsOfOwner) => acc.concat(tunnelsOfOwner), [])
        .map((tunnelObject) => new tunnelRecords.TunnelRecord(tunnelObject));
      return state.set('tunnels', List(allTunnels));
    }
    case STOP_TUNNEL.SUCCESS: {
      const tunnels = state.get('tunnels');
      const tunnelIndex = tunnels.findIndex((tunnel) => tunnel.id === payload.id);

      if (tunnelIndex >= 0) {
        return state.deleteIn(['tunnels', tunnelIndex]);
      }
      return state;
    }
    case ADD_TEAM_MEMBERSHIP.SUCCESS: {
      const teams = state.getIn(['user', 'teams']);
      return state.setIn(['user', 'teams'], [...teams, payload.team]);
    }
    case REMOVE_TEAM_MEMBERSHIP.SUCCESS: {
      const teams = state.getIn(['user', 'teams']);
      return state.setIn(['user', 'teams'], teams.filter((team) => team.id !== payload.team));
    }
    case RESET_ACCESS_KEY.SUCCESS:
      return state.setIn(['user', 'access_key'], payload[0].access_key);
    case teamsTypes.TEAMLIST_GET.SUCCESS:
    case teamsTypes.AUTOCOMPLETE_TEAMS_GET.SUCCESS:
    case teamsTypes.AUTOCOMPLETE_TEAMS_GET_OWN: {
      return state.set(
        'teams',
        List(payload.results
          .map((elem) => ({
            text: elem.name,
            value: elem.id,
          })),
        ).insert(0, { text: TM_DEFAULT_TEAM_DISPLAY_NAME, value: null }),
      );
    }
    default:
      return state;
  }
};

export default userDetailsReducer;
